import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  // strict: true,
  state: {
    address: '',
    addressc: '',//二级
    nums: 999,
    coupon_show: false,
    shopid: "",
    ks: 0,
    shopname: '',
    pid: '',
    sid: '',
    oid: "",//订单
    oname: "",//订单
    otype: "",//订单
    money: '',
    amoney: '',
    goods: [],
    s_address: '',
    spid: 0,
    spid1: '',
    ptf: 1,
    sonid: 33,//店中店id
    soncname: '',//店中店分类name
    tgood: [],//退货单
    scroll: 0,
    moid: 0,
    hsid: 0,
    commodity_id: '',
    pptf: '',
    qdf: true
  },
  mutations: {
    adds (state, i) {
      state.goods = i
    },
    change (state, i) {
      state.ks = i
    },
  },
  actions: {
  },
  getters: {
  }
})
